<div
  class="dc-roster"
  [class.dc-roster--loading]="isInitializing"
  [attr.aria-busy]="isBusy"
>
  <div class="dc-roster__overlay" *ngIf="isBusy">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <fieldset
    *ngIf="!isInitializing"
    class="dc-roster-fieldset"
    [disabled]="isReadOnly || isAutosavePending"
  >
    <div class="dc-row" *ngIf="showRosterFields">
      <div>
        <label for="dc-roster-billing-month">Billing Month</label>
        <input
          id="dc-roster-billing-month"
          type="month"
          class="form-control"
          [(ngModel)]="dcRoster.billingMonth"
          (ngModelChange)="onRosterFieldChanged()"
          pattern="[0-9]{4}-(0[1-9]|1[0-2])"
          placeholder="YYYY-MM"
          inputmode="numeric"
          maxlength="7"
          #billingMonth="ngModel"
          [class.is-invalid]="
            billingMonth.invalid && (billingMonth.dirty || billingMonth.touched)
          "
        />
        <div class="invalid-feedback">Use format YYYY-MM.</div>
      </div>
      <div>
        <label>DC Date</label>
        <input
          type="date"
          class="form-control"
          [(ngModel)]="dcRoster.dcDate"
          (ngModelChange)="onRosterFieldChanged()"
        />
      </div>
      <div>
        <label>DC Time</label>
        <input
          type="time"
          class="form-control"
          [(ngModel)]="dcRoster.dcTime"
          (ngModelChange)="onRosterFieldChanged()"
        />
      </div>
      <div>
        <label matTooltip="Estimated complete date">ETC Date</label>
        <input
          type="date"
          class="form-control"
          [(ngModel)]="dcRoster.etcDate"
          (ngModelChange)="onRosterFieldChanged()"
        />
      </div>
      <div>
        <label matTooltip="Estimated complete time">ETC Time</label>
        <input
          type="time"
          class="form-control"
          [(ngModel)]="dcRoster.etcTime"
          (ngModelChange)="onRosterFieldChanged()"
        />
      </div>
      <div>
        <label>Region</label>
        <select
          class="form-control"
          [(ngModel)]="dcRoster.region"
          (ngModelChange)="onRosterFieldChanged()"
        >
          <option value=""></option>
          <option *ngFor="let region of dcRegions" [value]="region.value">
            {{ region.label }}
          </option>
        </select>
      </div>
      <div>
        <label>DC Type</label>
        <select
          class="form-control"
          [ngModel]="dcRoster.dcType"
          (ngModelChange)="onDcTypeChange($event)"
        >
          <option value=""></option>
          <option *ngFor="let dcType of dcTypes" [value]="dcType.dcType">
            {{ dcTypeLabel(dcType) }}
          </option>
        </select>
      </div>
      <div>
        <label>DC Subtype</label>
        <select
          class="form-control"
          [ngModel]="dcRoster.dcSubtype"
          (ngModelChange)="onDcSubtypeChange($event)"
          [disabled]="!dcRoster.dcType"
        >
          <option value=""></option>
          <option
            *ngFor="let dcSubtype of dcSubtypes"
            [value]="dcSubtype.subType"
          >
            {{ dcSubtypeLabel(dcSubtype) }}
          </option>
        </select>
      </div>
    </div>

    <div class="row mt-3" *ngIf="shouldShowCollectionEventsTable">
      <div class="col-12">
        <table
          class="collection-events-table"
          [class.compact-events-table]="!showRosterFields"
        >
          <thead>
            <tr>
              <th *ngIf="shouldShowEventColumn('code')">Code</th>
              <th *ngIf="shouldShowEventColumn('duration')">Duration</th>
              <th *ngIf="shouldShowEventColumn('critical')">Critical</th>
              <th *ngIf="shouldShowEventColumn('collector')">Collector</th>
              <th *ngIf="shouldShowEventColumn('dcTypeOverride')">
                DC Type Override
              </th>
              <th *ngIf="shouldShowEventColumn('status')">Status</th>
              <th *ngIf="shouldShowEventColumn('actions')"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let event of dcRoster.collectionEvents; index as i">
              <td *ngIf="shouldShowEventColumn('code')">
                <div>{{ event.code }}</div>
                <small class="event-config-source" *ngIf="event.configSource">
                  Config: {{ event.configSource.dcType }} /
                  {{ event.configSource.dcSubtype }}
                </small>
              </td>
              <td *ngIf="shouldShowEventColumn('duration')">
                <input
                  type="number"
                  class="form-control"
                  [(ngModel)]="event.duration"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="onRosterFieldChanged()"
                />
              </td>
              <td *ngIf="shouldShowEventColumn('critical')">
                <select
                  class="form-control"
                  [(ngModel)]="event.critical"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="onRosterFieldChanged()"
                  [disabled]="!supportsCritical(event)"
                >
                  <option [ngValue]="null"></option>
                  <option
                    *ngFor="let criticalOption of criticalOptions"
                    [ngValue]="criticalOption"
                  >
                    {{ criticalOption }}
                  </option>
                </select>
              </td>
              <td *ngIf="shouldShowEventColumn('collector')">
                <app-collector-input
                  [auth0Id]="event.collectorAuthId"
                  [displayName]="
                    collectorNames.get(event.collectorAuthId) ?? ''
                  "
                  [disabled]="isReadOnly || isAutosavePending"
                  [allowForceSelection]="true"
                  [eligibilityContext]="
                    getCollectorEligibilityContext(event, i)
                  "
                  (auth0IdChange)="onCollectorChanged(event, $event)"
                ></app-collector-input>
              </td>
              <td *ngIf="shouldShowEventColumn('dcTypeOverride')">
                <select
                  class="form-control"
                  [(ngModel)]="event.dcTypeOverride"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="onRosterFieldChanged()"
                >
                  <option [ngValue]="null"></option>
                  <option
                    *ngFor="let dcType of dcTypes"
                    [value]="dcType.dcType"
                  >
                    {{ dcTypeLabel(dcType) }}
                  </option>
                </select>
              </td>
              <td *ngIf="shouldShowEventColumn('status')">
                <span class="status-badge status-{{ event.status ?? 'none' }}">
                  {{ getStatusLabel(event.status) }}
                </span>
              </td>
              <td *ngIf="shouldShowEventColumn('actions')">
                <button
                  mat-icon-button
                  type="button"
                  (click)="removeCollectionEvent(i)"
                  [disabled]="isReadOnly"
                >
                  <mat-icon>remove_circle_outline</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      class="row mt-3"
      *ngIf="dcRoster.dcSubtype && !isReadOnly && showAddCollectionEvent"
    >
      <div class="col-4">
        <label>Add Collection Event</label>
        <input
          type="text"
          class="form-control"
          [ngModel]="selectedCollectionEventOption"
          (ngModelChange)="onCollectionEventSearchChange($event)"
          [ngModelOptions]="{ standalone: true }"
          [matAutocomplete]="collectionEventAutocomplete"
          placeholder="Search event code or DC config"
        />
        <mat-autocomplete
          #collectionEventAutocomplete="matAutocomplete"
          [displayWith]="displayCollectionEventOption"
        >
          <mat-option
            *ngFor="let option of filteredCollectionEventOptions"
            [value]="option"
          >
            {{ collectionEventOptionLabel(option) }}
          </mat-option>
        </mat-autocomplete>
      </div>
      <div class="col-2" style="display: flex; align-items: end">
        <button
          mat-button
          type="button"
          (click)="addCollectionEvent(selectedCollectionEventOption)"
          [disabled]="!isCollectionEventOption(selectedCollectionEventOption)"
        >
          Add
        </button>
      </div>
    </div>
  </fieldset>
</div>
